// extracted by mini-css-extract-plugin
module.exports = {"root":"SplitLayout__root--O2qWp"};